import { render, staticRenderFns } from "./careManage.vue?vue&type=template&id=370b76ca&scoped=true"
import script from "./careManage.vue?vue&type=script&lang=js"
export * from "./careManage.vue?vue&type=script&lang=js"
import style0 from "./careManage.vue?vue&type=style&index=0&id=370b76ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b76ca",
  null
  
)

export default component.exports